import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IKanbanVehicle } from "../models/Vehicle";
import { DefaultResponseWithData } from "../models/system";

// Fetches the vehicles for the kanban board (stages Not On Site through Completed),
// oldest-first and capped at `max` cards across the whole board.
export default function useVehicleKanban(max: number = 25, enabled: boolean = true) {
  const { get } = useApiHelper();

  const kanban = useQuery(
    ["vehicle", "kanban", max],
    () => get<DefaultResponseWithData<IKanbanVehicle[]>>(`/vehicle/kanban?max=${max}`),
    {
      enabled,
      staleTime: 1000 * 60 * 2, // 2 minutes
      refetchInterval: 1000 * 60 * 5, // 5 minutes
    }
  );

  return { kanban };
}
